import Cookies from "js-cookie";
import React from "react";
import { Redirect } from "react-router-dom";
import { getInfo } from "./hooks";

export function getRedirection(): JSX.Element {
    const info = getInfo();
    const admin = Cookies.get('admin');
    if (admin) {
        return <Redirect to="/admin" />;
    }
    switch (info?.intent) {
        case "writer":
            return <Redirect to="/" />;
        case "critic":
            return <Redirect to="/critic" />;
        case "producer":
            return <Redirect to="/critic" />;
        case "platform":
            return <Redirect to="/critic" />;
        default:
            return <Redirect to="/signup/preferences" />;
    }
}